import cronstrue from "cronstrue";
import { convertUtcTimeToLocal } from "./datetime";

export function getCronDescriptionWithTzOffset(scheduleInterval) {
  try {
    const adjustedCron = convertCronToLocalTimezone(scheduleInterval);
    let description = cronstrue.toString(adjustedCron, { verbose: true });

    if (description.startsWith("At ")) {
      description = description.replace("At ", "");
    }
    return description;
  } catch (err) {
    return "Invalid cron expression";
  }
}

export function convertCronToLocalTimezone(cronExpression) {
  const parts = cronExpression.trim().split(/\s+/);

  if (cronExpression.startsWith("@") || parts.length < 5) {
    return cronExpression;
  }

  const hasSeconds = parts.length >= 6;
  const minuteIndex = hasSeconds ? 1 : 0;
  const hourIndex = hasSeconds ? 2 : 1;
  const minutePart = parts[minuteIndex];
  const hourPart = parts[hourIndex];

  if (/^\d+$/.test(hourPart) && /^\d+$/.test(minutePart)) {
    const utcHour = parseInt(hourPart, 10);
    const utcMinute = parseInt(minutePart, 10);

    if (!isNaN(utcHour) && !isNaN(utcMinute)) {
      const { hour: localHour, minute: localMinute } = convertUtcTimeToLocal(utcHour, utcMinute);
      parts[hourIndex] = localHour.toString();
      parts[minuteIndex] = localMinute.toString();
    }
  }

  return parts.join(" ");
}
